import { MembershipLevel } from "types/auth";

/**
 * 등급 표시. **판정에는 쓰지 않는다** — 그건 서버가 준 `permissions` 의 몫이다.
 *
 * 유저 목록과 멤버십 목록이 같은 라벨을 써야 해서 한 곳에 뒀다. 한쪽만 고치면
 * 같은 등급이 화면마다 다른 이름으로 보인다.
 */
export const LEVEL_LABEL: Record<
  MembershipLevel,
  { text: string; color: "default" | "info" | "success" | "warning" }
> = {
  basic: { text: "베이직", color: "default" },
  pro: { text: "프로", color: "info" },
  // `elite` 는 «엘리트» 다. **그룹 이름을 등급 이름으로 쓰지 않는다.**
  //
  // 이 등급을 쓰는 그룹이 `프리즘임직원` 하나뿐이라 «임직원» 이라고 그렸었는데,
  // 그러면 유저 목록에서 «등급: 임직원 · 멤버십: 프리즘임직원» 이 나란히 찍히고,
  // 그룹을 새로 만들 때 «VIP고객» 의 등급으로 «임직원» 을 골라야 한다.
  // `pro` 가 «프로» 이고 그 그룹이 `어스얼라이언스`·`투자권유인`·`개별고객` 인 것과
  // 같은 축이다 — 등급은 권한의 단계고, 그룹 이름은 누구인지를 말한다.
  elite: { text: "엘리트", color: "success" },
  admin: { text: "관리자", color: "warning" },
};

/**
 * 등급 칸을 정렬할 때 쓰는 **표시 순서**.
 *
 * 문자열로 정렬하면 `admin · basic · elite · pro` 가 되어 사람이 기대하는 순서와
 * 무관해진다. 낮은 등급부터 높은 등급 순으로 보이게 한다.
 *
 * ⚠️ **판정에 쓰지 않는다.** 권한은 서버가 준 `permissions` 하나로만 정한다.
 * 서버가 `rank` 를 일부러 안 내려주는 것도 같은 이유다 — 여기 숫자는 화면에서
 * 줄을 세우는 용도이고, 정책이 바뀌어도 이 파일만 고치면 된다.
 */
export const LEVEL_ORDER: Record<MembershipLevel, number> = {
  basic: 0,
  pro: 1,
  elite: 2,
  admin: 3,
};
